import { GET_ALL_PROMO} from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_ALL_PROMO:
            return action.payload;
        default:
            return state;
    }
}